import API, { toHardLink } from '../app.api';
import ApiResources from '../../helpers/APIResource';
import qs from 'qs';

export const getPathResources = async (body) => {
    const res = await API.post(`/api/v1/module/drive/path`, { ...body });
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d;
};

export const addCommentToFile = async (fileId, body) => {
    const res = await API.post(`/api/v1/module/drive/file/${fileId}/comment`, { text: body });
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d;
};

export const getFolderStructure = async () => {
    const res = await API.get('/api/v1/module/drive/folder/architecture');
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d;
}

export const syncEntityDrivePermission = async () => {
    const res = await API.get('/api/v1/module/drive/sync');
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d;
}

export const getDocumentTypes = async () => {
    const res = await API.get('/api/v1/module/drive/tag');
    const d = res.data;
    for (let elem of d.data) {
        if (elem?.constant === "system_document_type") {
            return elem;
        }
    }
    return {};
}

export const searchFiles = async (searchOpts) => {
    const res = await API.get('/api/v1/module/drive/search', {
        params: {
            ...(searchOpts || {}),
            content: '0',
            limit: 100,
            "orderBy[updatedAt]": 'DESC'
        }
    });
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d;
}

export const getFileInformation = async (fileId) => {
    const res = await API.get(`/api/v1/module/drive/file/${fileId}/information`);
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d;
}

export const downloadFileHardLink = (fileId) => {
    return toHardLink(`/api/v1/module/drive/file/${fileId}/download`);
}

export const uploadFile = async (formData, folderTarget, config) => {
    try {
        const res = await API.post(
            // URL
            `/api/v1/entity/me/drive/upload?folderTarget=${folderTarget}`,
            // Data
            formData,
            // Config
            {
                ...(config || {}),
                queryString: {
                    checksumStrategy: 'CONTINUE_ON_CHECKSUM_FAILURE'
                },
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        );
        return res;
    } catch (err) {
        return {
            error_status: err?.response?.data?.error_status ?? 500,
            information: err?.response?.data?.information ?? 'Internal server error',
            message: err?.response?.data?.information ?? 'Error'
        };
    }
}

export const getUploadConfiguration = async () => {
    try {
        const res = await API.get('/api/v1/module/drive/configuration');
        return res.data;
    } catch (err) {
        return {
            uploadSizeLimit: process.env.REACT_APP_MAX_FILE_SIZE || '2M',
            proxyMaxSize: process.env.REACT_APP_MAX_FILE_SIZE || '2M',
        };
    }
}

export const getBucketList = async () => {
    const res = await API.get('/api/v1/module/drive/bucket/list');
    const d = res.data;
    ApiResources.hydrateResource(d);
    return d.data;
}

export const uploadFileToBucket = async (formData, bucketId, config) => {
    try {
        const res = await API.post(
            // URL
            `/api/v1/module/drive/drive/bucket/upload/${bucketId}`,
            // Data
            formData,
            // Config
            {
                ...(config || {}),
                queryString: {
                    checksumStrategy: 'CONTINUE_ON_CHECKSUM_FAILURE'
                },
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        );
        return res;
    } catch (err) {
        return {
            error_status: err?.response?.data?.error_status ?? 500,
            information: err?.response?.data?.information ?? 'Internal server error',
            message: err?.response?.data?.information ?? 'Error'
        };
    }
}